import React from 'react';
import DynamicHeader from '../Header/DynamicHeader';

const Agreement = ({ onAgree, onCancel }) => (
  <div>
   {/* <div className="header-container">
          <div className="header-content">
            <h2 className="header-subtitle">
              <span className="color-sp-lookna"> Terms and Conditions</span><br></br><br></br>
              
              FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
  
            </h2>
          
          </div>
          <div className="details-borders"></div>
       
        </div> */}
        <DynamicHeader/>
  <div className="privacy-policy-container" style={{ maxWidth: 1200, margin: " 0 auto", padding: 32, position: 'relative' }}>
    <h2 style={{ color: '#b38cf7', fontWeight: 600, fontSize: '1.35rem', marginBottom: 14 }}>Your Agreement</h2>
    <div style={{ color: '#b0aecd', fontSize: '0.95rem', marginBottom: 18 }}>Last Reviewed: May 29, 2025</div>
    <div style={{ fontSize: '1rem', color: '#fafafc' }}>
      <p>
        Welcome to our site. Please read these terms carefully before using our services.
      </p>

      <h4>1. Your Agreement</h4>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed rhoncus, eros nec malesuada tincidunt, augue nisi fermentum ex, ac porttitor purus justo nec urna. Suspendisse accumsan euismod elit, sed viverra nulla dictum et. Etiam hendrerit efficitur urna, vitae dictum lectus dictum nec.
      </p>

      <h4>2. Privacy</h4>
      <p>
        Duis posuere lectus euismod, volutpat mi nec, placerat tortor. Nullam imperdiet diam sit amet mauris suscipit, eget lacinia purus sagittis. Praesent vitae neque vel dui euismod imperdiet.
      </p>

      <h4>3. Linked Sites</h4>
      <p>
        In bibendum purus ac lacus tempus, nec egestas purus convallis. Curabitur suscipit, est in eleifend ullamcorper, nibh velit varius enim, eget commodo felis erat at magna. Morbi ac scelerisque lectus.
      </p>

      <h4>4. Forward Looking Statements</h4>
      <p>
        Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Nullam tempus dolor sit amet enim dictum, quis pulvinar dui faucibus.
      </p>

      <h4>5. Disclaimer of Warranties and Limitation of Liability</h4>
      <p>
        Proin pretium felis et volutpat cursus. Nulla facilisi. Mauris rhoncus, arcu at dignissim efficitur, urna nisi tincidunt orci, ac lobortis eros nibh ut erat. Sed ac ex nec sem sollicitudin dictum.
      </p>

      <h4>6. Exclusions and Limitations</h4>
      <p>
        Cras eu enim in nulla malesuada dictum. Morbi quis sagittis risus, vitae scelerisque sem. Suspendisse potenti. Etiam nec cursus ex. Suspendisse bibendum erat id augue eleifend pretium.
      </p>
    </div>

    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 30 }}>
      <button
        onClick={onCancel}
        style={{
          background: "#2d2d34",
          color: "#b0aecd",
          border: "none",
          padding: "8px 26px",
          borderRadius: "7px",
          cursor: "pointer",
          fontWeight: 500
        }}
      >
        Cancel
      </button>
      <button
        onClick={onAgree}
        style={{
          background: "#b38cf7",
          color: "#fff",
          border: "none",
          padding: "8px 26px",
          borderRadius: "7px",
          cursor: "pointer",
          fontWeight: 500
        }}
      >
        Agree
      </button>
    </div>
  </div>
  </div>
);

export default Agreement;
